import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { AppEnv } from './app/core/constants/app.constant';
import { NucbotWidgetRegistry } from '@nphs-comm/nphs-comm-nucbot-widget'


if (environment.name !== AppEnv.Local) {
 // enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .then(ref => {
    const registry = ref.injector.get(NucbotWidgetRegistry);
    registry.register(ref.injector);
  })
  .catch((err) => console.error(err));
